import _createClass from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/**
 * Output Feedback block mode.
 */
import { BlockCipherMode } from './cipher-core.js';
export var OFB = /*#__PURE__*/function (_BlockCipherMode) {
  _inherits(OFB, _BlockCipherMode);

  var _super = _createSuper(OFB);

  function OFB() {
    _classCallCheck(this, OFB);

    return _super.apply(this, arguments);
  }

  return OFB;
}(BlockCipherMode);

OFB.Encryptor = /*#__PURE__*/function (_OFB) {
  _inherits(_class, _OFB);

  var _super2 = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super2.apply(this, arguments);
  }

  _createClass(_class, [{
    key: "processBlock",
    value: function processBlock(words, offset) {
      var _words = words; // Shortcuts

      var cipher = this._cipher;
      var blockSize = cipher.blockSize;
      var iv = this._iv;
      var keystream = this._keystream; // Generate keystream

      if (iv) {
        this._keystream = iv.slice(0);
        keystream = this._keystream; // Remove IV for subsequent blocks

        this._iv = undefined;
      }

      cipher.encryptBlock(keystream, 0); // Encrypt

      for (var i = 0; i < blockSize; i += 1) {
        _words[offset + i] ^= keystream[i];
      }
    }
  }]);

  return _class;
}(OFB);

OFB.Decryptor = OFB.Encryptor;